import {Component} from '@angular/core';
import { MdbButtonComponent } from '../../../utils/mdb-button/mdb-button.component';
import { SpinnerComponent } from '../../../utils/spinner/spinner.component';
import {FormGroup, ReactiveFormsModule} from '@angular/forms';
import { Router } from '@angular/router';
import { VehicleService } from '../../../../services/resources/vehicle.service';
import { CustomNotificationService } from '../../../../services/utils/custom-notification.service';
import { HttpErrorsService } from '../../../../services/utils/http-errors.service';
import { SafeUpdateService } from '../../../../services/utils/safe-update.service';
import { AConcreteResource } from '../../../AConcreteResource';
import { VehicleModel } from '../../../../models/resources/vehicle.model';
import { finalize } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { VehicleFormComponent } from '../../../forms/vehicle-form/vehicle-form.component';

@Component({
  selector: 'app-vehicle',
  imports: [
    VehicleFormComponent,
    MdbButtonComponent,
    SpinnerComponent,
    ReactiveFormsModule
  ],
  templateUrl: './vehicle.component.html',
  styleUrl: './vehicle.component.scss',
})
export class VehicleComponent extends AConcreteResource<VehicleModel> {
  loading: boolean = false;
  formGroup: FormGroup | undefined;

  constructor(
    router: Router,
    private vehicleService: VehicleService,
    private httpErrorService: HttpErrorsService,
    private notificationService: CustomNotificationService,
    private safeUpdateService: SafeUpdateService
  ) {
    super(router, vehicleService);
  }

  submit(serverResource: any = null, overrideValues: { [key: string]: any } = {}) {
    this.formGroup!.markAllAsTouched();

    if (this.formGroup!.invalid) return;

    this.loading = true;

    let resource = this.formGroup?.value;

    resource.updatedAt = this.model()!.updatedAt;

    resource.location = resource.location?.id ? {
      id: resource.location?.id,
      updatedAt: resource.location?.updatedAt,
    } : null;

    resource.vitabeneEmployee = resource.vitabeneEmployee?.id ? {
      id: resource.vitabeneEmployee?.id,
      updatedAt: resource.vitabeneEmployee?.updatedAt,
    } : null;

    if (serverResource)
      resource = this.safeUpdateService.handleResource(resource, serverResource, overrideValues);

    this.vehicleService
    .update(this.model()!.id, resource)
    .pipe(finalize(() => (this.loading = false)))
    .subscribe({
      next: () => {
        this.notificationService.success('CHANGES_SUCCESSFULLY_SAVED');
      },
      error: (e: HttpErrorResponse) => {
        this.httpErrorService.handleError(e, (newServerResource, newOverrideValues) => {
          this.submit(newServerResource, newOverrideValues);
        });
      },
    });
  }
}
